import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
  VSwitch,
} from 'vuetify/components';

import GroupedFieldsExpansionPanel from '@/components/form/GroupedFieldsExpansionPanel.vue'
import ClientDetail from '@/components/modules/clients/Detail.vue'
  
import type { FormField } from '@/types/form';


export const CREATE_FORM: FormField[] = [  
  { value: 'client_type', label: 'Tipo de Cliente', component: VAutocomplete, required: false, col: 6, mdcol:12, fetchOptions: 'getClientTypes', itemText: 'name', 
    itemValue: 'name',
    transform: (value: any) => ({
      client_type_id: value?.id,
    }) 
  },
  { value: 'commercial_name', label: 'Nombre Comercial', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'agencies', label: 'Agencia(s)', component: VAutocomplete, required: false, col: 6, mdcol:12, fetchOptions: 'searchAgencies',
    itemText: (item: any) => item?.attributes?.commercial_name || item?.commercial_name || item?.name || 'Sin nombre',
    itemValue: (item: any) => item,
    multiple: true,
    // ✅ Lógica condicional para ocultar si client_type contiene "agencia"
    dependsOn: 'client_type',
    dependsBehavior: 'hidden',
    dependsCondition: {
      value:'agencia',
      condition:'includes'
    },
    transform: (value: any) => ({
      agency_ids: Array.isArray(value)
        ? value.map(v => v?.id ?? v)
        : value?.id ?? value
    }),
   },
  {
    value: 'fiscal_data',
    label: 'Datos Fiscales',
    isJsonArray: true,
    plainJson: true,
    component: GroupedFieldsExpansionPanel,
    col: 12,
    children: [
      { value: 'legal_name', label: 'Razón Social', component: VTextField, required: true, col: 6 },
      { value: 'tax_id', label: 'RFC', component: VTextField, required: true, col: 6 },
      { value: 'tax_system', label: 'Régimen Fiscal', component: VAutocomplete, required: true, col: 6, fetchOptions: 'searchFiscalRegiments', itemText: 'label',
        itemValue: (item: any) => item,
        transform: (value: any) => ({
          tax_system: value?.value,
        })
      },
      { value: 'preferred_payment_method', label: 'Método de Pago', component: VAutocomplete, required: false, col: 6, fetchOptions: 'searchPaymentMethods', itemText: 'label',
        itemValue: (item: any) => item,
        transform: (value: any) => ({
          tax_system: value?.value,
        })
      },
    ],
  },
  {
    value: 'address',
    label: 'Dirección',
    isJsonArray: true,
    plainJson: true,
    component: GroupedFieldsExpansionPanel,
    col: 12,
    children: [
      { value: 'street', label: 'Calle', component: VTextField, required: false, col: 6 },
      { value: 'exterior', label: '# Exterior', component: VTextField, required: false, col: 6 },
      { value: 'interior', label: '# Interior', component: VTextField, required: false, col: 6 },
      { value: 'neighborhood', label: 'Colonia', component: VTextField, required: false, col: 6 },
      { value: 'zip', label: 'Código Postal', component: VTextField, required: true, col: 6 },
      { value: 'city', label: 'Ciudad', component: VTextField, required: false, col: 6 },
      { value: 'municipality', label: 'Municipio', component: VTextField, required: false, col: 6 },
      { value: 'state', label: 'Estado', component: VTextField, required: false, col: 6 },
      { value: 'country', label: 'País', component: VTextField, required: false, col: 6 }, 
    ],
  },
];

const idFieldMappings: Record<string, string> = {
  agency_ids:'agencies'
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const relatedKey = idFieldMappings[field.value];
  if (relatedKey) {
    return {
      ...field,
      parse: (_: any, item: any) => item[relatedKey] || null,
      transform: (val: any) => ({
        [field.value]: field.multiple
          ? (Array.isArray(val)
              ? val.map(v => v?.[field.itemValue || 'id'] ?? v)
              : [])
          : val?.id ?? val
      })
    };
  }
  return field;
})]

export const EDIT_FORMs: FormField[] = [  
  { value: 'client_type', label: 'Tipo de Cliente', component: VAutocomplete, required: false, col: 6, mdcol:12, fetchOptions: 'getClientTypes', itemText: 'name', itemValue: 'id' },
  { value: 'commercial_name', label: 'Nombre Comercial', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'agencies', label: 'Agencia(s)', component: VAutocomplete, required: false, col: 6, mdcol:12, fetchOptions: 'searchAgencies', itemText: 'attributes.commercial_name', itemValue: 'id', 
    multiple: true,
    // ✅ Lógica condicional para ocultar si client_type contiene "agencia"
    dependsOn: 'client_type',
    dependsBehavior: 'hidden',
    dependsCondition: (val: any) => {
      if (typeof val === 'object' && val?.name) {
        return val.name.toLowerCase().includes('agencia');
      }
      return false;
    },
  },
  {
    value: 'fiscal_data',
    label: 'Datos Fiscales',
    isJsonArray: true,
    plainJson: true,
    component: GroupedFieldsExpansionPanel,
    col: 12,
    children: [
      { value: 'legal_name', label: 'Razón Social', component: VTextField, required: true, col: 6 },
      { value: 'rfc', label: 'RFC', component: VTextField, required: true, col: 6 },
      { value: 'tax_system', label: 'Régimen Fiscal', component: VAutocomplete, required: true, col: 6, fetchOptions: 'searchFiscalRegiments', itemText: 'label', itemValue: 'value'},
      { value: 'preferred_payment_method', label: 'Método de Pago', component: VAutocomplete, required: false, col: 6, fetchOptions: 'searchPaymentMethods', itemText: 'label', itemValue: 'value'},
    ],
  },
  {
    value: 'address',
    label: 'Dirección',
    isJsonArray: true,
    plainJson: true,
    component: GroupedFieldsExpansionPanel,
    col: 12,
    children: [
      { value: 'street', label: 'Calle', component: VTextField, required: false, col: 6 },
      { value: 'exterior', label: '# Exterior', component: VTextField, required: false, col: 6 },
      { value: 'interior', label: '# Interior', component: VTextField, required: false, col: 6 },
      { value: 'neighborhood', label: 'Colonia', component: VTextField, required: false, col: 6 },
      { value: 'zip', label: 'Código Postal', component: VTextField, required: true, col: 6 },
      { value: 'city', label: 'Ciudad', component: VTextField, required: false, col: 6 },
      { value: 'municipality', label: 'Municipio', component: VTextField, required: false, col: 6 },
      { value: 'state', label: 'Estado', component: VTextField, required: false, col: 6 },
      { value: 'country', label: 'País', component: VTextField, required: false, col: 6 }, 
    ],
  },
];

export const HEADERS = [
  { title: '', value: 'eye_detail', format: 'text', sortable: false },
  { title: 'ID', value: 'id', format: 'text', sortable: true },
  { title: 'Razón Social', value: 'attributes.legal_name', format: 'text', sortable: false },
  { title: 'Nombre Comercial', value: 'attributes.commercial_name', format: 'text', sortable: false },
  { title: 'RFC', value: 'rfc', format: 'attributes.text', sortable: true },
  { title: 'Régimen Fiscal', value: 'attributes.tax_system', format: 'text', sortable: true },
  { title: 'Dirección', value: 'attributes.address', format: 'text', sortable: false },
  { title: 'Correo', value: 'attributes.email', format: 'text', sortable: true },
  { title: 'Teléfono', value: 'attributes.phone', format: 'text', sortable: true },
  { title: 'Método de Pago', value: 'attributes.preferred_payment_method', format: 'text', sortable: false },
  { title: 'Tipo de Cliente', value: 'attributes.client_type', format: 'text', sortable: false },
  { title: 'Tipo', value: 'type', format: 'text', sortable: false },
  { title: 'Agencia', value: 'attributes.belongs_to_agency', format: 'boolean', sortable: true },
  { title: 'Contacto Principal', value: 'attributes.primary_contact', format: 'text', sortable: false },
  { title: 'Cuentas', value: 'attributes.accounts', format: 'text', sortable: false },
  { title: 'Agencias', value: 'attributes.agencies', format: 'text', sortable: false },
  { title: 'Vendedor', value: 'user', format: 'text', sortable: true },
];

export const DEFAULT_HEADER_ORDER = [
  'eye_detail',
  'id',
  'attributes.commercial_name',
  'attributes.client_type',
  'attributes.primary_contact',
  'attributes.accounts',
  'attributes.agencies',
];

export const DETAIL = {
  expand_table: false,
  eye_detail: true,
  key: 'all',
  component: ClientDetail
};

export const FILTERS = [
  { value: 'id', label: 'ID', component: VTextField },
  { value: 'commercial_name', label: 'Nombre Comercial', component: VTextField },
  { value: 'email', label: 'Correo Electrónico', component: VTextField },
  { value: 'phone', label: 'Teléfono', component: VTextField },
  { value: 'user_id', label: 'Vendedor', component: VAutocomplete, fetchOptions: 'searchUsers', itemText: 'name', itemValue: 'id'},
  { value: 'legal_name', label: 'Razón Social', component: VTextField },
  { value: 'tax_id', label: 'RFC', component: VTextField },
  { value: 'tax_system', label: 'Régimen Fiscal', component: VAutocomplete, fetchOptions: 'searchFiscalRegiments', itemText: 'label', itemValue: 'value'},
];